import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/TabPanel.js";

/**
    * class HSN.ProductOptionSelector
    *
    * Progressively enhances a definition list full of option radio buttons and
    * labels to be more interactive.
    **/
HSN.ProductOptionSelector = function (config) {
    /**
        * new HSN.ProductOptionSelector(config)
        * - config (Object): A configuration object for the [[HSN.ProductOptionSelector]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the ProductOptionSelector should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector
        *     that will ultimately resolve to an HTML element will act as the container for the set of options.
        *   - favoriteLink: jQuery Selector for favorite heart,
        *   preSelectedWebId: scope._preSelectedWebId,
        *   buySelector: scope,
        *   imageContainer: scope._imageContainer,
        *   useSimpleMainImage: scope._useSimpleMainImage
        **/

    // ReSharper disable once InconsistentNaming
    var __scope = this;
    this.eventIdentity = config.eventIdentity || crypto.randomUUID();
    this._variantInfo = config.variantInfo;
    this._application = config.application;
    this._container = $(config.container);
    this._favoriteLink = $(config.favoriteLink);
    this._preSelectedWebId = config.preSelectedWebId;
    this._isPlusSizeVariantSelected = false;
    this._imageContainer = config.imageContainer;
    this._useSimpleMainImage = config.useSimpleMainImage;
    this._isMobile = HSN.Instance().DeviceInformation.IsMobile;
    this._productImage = { href: null, zoom: null };
    this._showDefaultImage = true;

    // Keep display in sync with the variantInfo
    this._variantInfo.onChange(() => {
        this._updateDisplay();
    });

    this.init = () => {
        this._container.addClass('product-option-selector');

        // ReSharper disable once UnusedLocals
       
        if (__scope._imageContainer) {
            this.SetDefaultImage();
        }

        //ignore hover events used for product option preview on touch devices
        if (!Modernizr.touchevents) {
            //handler switching main images for variants on event(hover)
            this._container.on('mouseleave', '.color-option, .btn-styled', function () {
                let $this = $(this);
                __scope._showDefaultImage = true;
                setTimeout(function () {
                    if (__scope._showDefaultImage) {
                        __scope._updateProductImage($this, __scope._productImage, 'mouseleave');
                    }
                }, 10);
            });

            this._container.on('blur', '.color-option input, .btn-styled input', function () {
                let $this = $(this);
                __scope._showDefaultImage = true;
                setTimeout(function () {
                    if (__scope._showDefaultImage) {
                        __scope._updateProductImage($this, __scope._productImage, 'blur');
                    }
                }, 10);
            });
        }

        //handler switching main images for variants on event(hover or click)
        this._container.on(Modernizr.touchevents ? 'click' : 'mouseenter focus', '.color-option, .color-option .label input', function (e) {
            let $this = $(this);
            __scope._showDefaultImage = false;
            let controlVariantEle = $('.control-variant.left');
            if (controlVariantEle.length && controlVariantEle.is(':visible')) {
                if (controlVariantEle.find('#inline-video-container').is(':visible')) {
                    return;
                }
            } else {
                if ($('.variant-a-left.left .product-image-container #new-inline-video-container').is(':visible')) {
                    return;
                }
            }

            var $input = $this.find('input');
            if ($this.is('input')) {
                $input = $this;
            }
            var images = $input.data('images');
            var imageName = $input.data('image-name');

            var isPlusSize = __scope.IsPlusSizeGroupSelected();

            __scope.SwapMainImage(images, imageName, isPlusSize);
        });

        // handler tab-navigation for Attributes -- (ADA)

        this._container.on('focus', 'input[name^="product-modal-option"], input[name^="product-option-group"]', function (e) {
            $(this).parent().addClass('highlighted-for-tab');

            /* slide left/right when focus on hidden items of carousel */
            if ($(this).closest('.slick-slide').length) {
                const slickEle = $(this).closest('.slick-slider');
                const slickIndex = parseInt($(this).closest('.slick-slide').attr('data-slick-index'));
                slickEle.slick('slickGoTo', slickIndex, false);
            }
        });
        this._container.on('focusout', 'input[name^="product-modal-option"], .btn-styled:has(> input[name^="product-modal-option"]), input[name^="product-option-group"], .btn-styled:has(> input[name^="product-option-group"])', function (e) {
            $(this).parent().removeClass('highlighted-for-tab');
        });

        //handler switching main images for variants on event(hover or click)
        this._container.on(Modernizr.touchevents ? 'click' : 'mouseenter focus', '.btn-styled, .groupLabel > span, .btn-styled input', function (e) {
            if (e.type === 'mouseenter' && $(this).is('.groupLabel > span')) { return; }

            __scope._showDefaultImage = false;

            var color = $('.btn-styled-swatch.selected');
            if (color.length < 1) {
                __scope._showDefaultImage = true;
                return;
            }

            var $input = $(this).find('input');
            if ($(this).is('input')) {
                $input = $(this);
            }
            var $colorInput = $(color).find('input');
            var images = $colorInput.data('images');
            var imageName = $colorInput.data('image-name');

            var isPlusSize = $input.data('isPlusSizeCode');
            if (isPlusSize == null) {
                isPlusSize = $input.data('isPlusSizeGroup');
            }

            __scope.SwapMainImage(images, imageName, isPlusSize);
        });

        //handle variant option select box override
        this._container.on('change', '.variant-selector-override', function () {
            var selectedValue = $(this).val();
            var nearestDd = $(this).siblings('ul');
            var matchingLabel = nearestDd.find('.label > input[data-value="' + selectedValue + '"]');
            if (matchingLabel.length > 0) {
                matchingLabel.click();
            }
        });

        //handle group selection (For example, Group: [Size Type] and [Size])
        this._container.on('click keydown', '.variant-group-tab-items .label, .variant-group-tab-items .label > input', function (e) {
            if (e.type === 'keydown' && e.key !== 'Enter') {
                return;
            }

            e.preventDefault();

            let $label, $input;
            if ($(this).is('.label')) {
                $label = $(this);
                $input = $label.find('> input');
            } else {
                $input = $(this);
                $label = $input.closest('.label');
            }

            //Tab functionality moved from <a> to button
            $label.parent()
                .addClass('active')
                .siblings()
                .removeClass('active');

            let $href = $label.data('href');
            $href = $href.substr($href.indexOf('#') + 1);
            $('#' + $href, this._container)
                .addClass('active')
                .siblings()
                .removeClass('active');

            let changed = $input.attr('data-checked') == 'false';

            var $groupDd = $label.closest('.variant-group-tab-items');
            var relatedDt = $groupDd.siblings('.tabs-label');
            var selectedLabel = relatedDt.find('label.product-option-label');
            var selectedGroupLabel = $groupDd.siblings('.tabs-label:first').find('> label');
            // Update "Selected, " text for aria-label
            $('input[name="' + selectedGroupLabel.data('selection-name') + '"]').attr('data-checked', 'false');
            $input.attr('data-checked', 'true');

            if (selectedLabel.text().length === 0) {
                selectedLabel.text(selectedLabel.data('text'));
                selectedLabel.addClass(selectedLabel.data('class'));
                selectedLabel.show();
                selectedLabel.next('span').css('display', 'inline');
            }

            selectedGroupLabel.removeClass('inline-error');
            $('div[class*="errors"]').remove();
            $('input[class*="has-error"]').removeClass('has-error');
            $('input[class*="inline-error"], select[class*="inline-error"]').removeClass('inline-error');

            $('.label', $groupDd).removeClass('checked-selected waitlisted-selected');
            // Remove "Selected, " text from aria-label
            $('.label ', $groupDd).each(function () {
                const inputDesc = $(this).find('> .option-description').text();
                $(this).find('input').attr('aria-label', inputDesc);
            });

            //set selected option description
            const $groupTitle = $groupDd.prevAll('.tabs-label:first');
            __scope._updateGroupTitle($groupTitle, $input.data('label'));

            if ($label.hasClass('waitlisted')) {
                $label.addClass('waitlisted-selected');
            }
            else {
                $label.addClass('checked-selected');
            }
            // Update "Selected, " text for aria-label
            var inputDescription = $('> .option-description', $label).text();//span with descripcion
            $input.attr('aria-label', (($label.hasClass('checked-selected') || $label.hasClass('waitlisted-selected')) ? 'Selected, ' : '') + inputDescription);

            __scope._isPlusSizeVariantSelected = $input.data('is-plus-size-group');

            var colorVariantLabel = __scope.GetSelectedVariant('C');
            if (colorVariantLabel) {
                var alternateImages = colorVariantLabel.find('> input').data('images');
                __scope.HandleOptionChanged(alternateImages);
            }
            else {//no colors selected, so switch on default image
                var mainImages = __scope._imageContainer ? __scope.GetImageData(__scope._imageContainer.find('img')) : null;
                __scope.HandleOptionChanged(mainImages);
            }

            //clear out size variant selected
            var sizeVariantLabel = __scope.GetSelectedVariant('S', $label.closest('ul').parent());
            if (sizeVariantLabel) {
                __scope.DeactivateOptionLabel(sizeVariantLabel);
            }

            if (changed) {
                __scope._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.GROUP_CHANGED, __scope._isPlusSizeVariantSelected, __scope.eventIdentity);
            }
        });

        //handle input selection             
        this._container.on('keydown click', 'input[name^="product-modal-option"], .btn-styled:has(> input[name^="product-modal-option"]), .btn-styled-swatch:has(> input[name^="product-modal-option"])',
            function (e) {

                if (e.type === 'click' || e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                    var $selectedInput = $(this);
                    if (!$selectedInput.is('input')) {
                        $selectedInput = $selectedInput.find('input');
                    }

                    var $selectedLabel = $selectedInput.parent('.label');

                    var hasMatrix = $('.matrix-options', __scope._container).length;
                    var hasMatrixSelect = $('.matrix-options select').length !== 0;

                    if (((!hasMatrixSelect && $('.matrix-options .selected', __scope._container).length === 0) || (hasMatrixSelect && $('.matrix-options select', __scope._container).val() === 'Please select...')) && hasMatrix) {
                        var matrixErrorMessage = $('div.tabs-label:first label:not(".waitlist-explainer") .matrix-selection-error', __scope._container);
                        var hasMatrixErrorMessage = matrixErrorMessage.length;
                        if (!hasMatrixErrorMessage) {
                            let labelTxt = $('div.tabs-label:first label:not(".waitlist-explainer")', __scope._container).html().toLowerCase();
                            labelTxt = labelTxt.includes('select') ? labelTxt : 'select ' + labelTxt;
                            $('div.tabs-label:first label:not(".waitlist-explainer")', __scope._container).append('<span class="matrix-selection-error">Please ' + labelTxt + ' first.</span>');
                        }
                        else {
                            matrixErrorMessage.show();
                            $(this).prop('checked', false);
                        }
                        return;
                    }

                    __scope.ActivateOptionLabel($selectedLabel, true);


                }
            }
        );

        $('body').on('click', function () {
            $('.highlighted-for-tab').removeClass('highlighted-for-tab');
        });
        
        //Refresh modal to show modal for particular product in matrix
        $('.matrix-options', this._container).on('click keydown', 'a', function (e) {
            if (e.type === 'click' || e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                var url = $(this).data('url') || $(this).attr('href');
                __scope._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, $(this).data('id'), url, $(this).data('edit-bi-id'), $(this).data('edit-bag-id'), __scope.eventIdentity);
            } else if (e.type === 'keydown' & e.key === 'Tab') {
                return true;
            }
            return false;
        });

        if (__scope._isMobile) {//Prevent default anchor behavior for mobile, handling via events
            // look into unifying mobile/desktop approach, moving away from anchor tags
            $('.matrix-options', this._container).on('click', 'a', function (e) {
                e.preventDefault();
            });
        }

        //Refresh modal to show modal for particular product in matrix, drop down version(large # of variants)
        this._container.on('change', '.matrix-selector', function () {
            e.preventDefault();
            e.stopPropagation();

            var selected = $(this).find('option:selected');
            var url = $(this).data('url') || $(this).attr('href');
            __scope._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, selected.val(), url, selected.data("edit-bi-id"), selected.data('edit-bag-id'), __scope.eventIdentity);

            return false;
        });

        this._variantInfo.setVariantById(this._preSelectedWebId);

        var preselectedSizeCode = this._variantInfo.getSelectedCodeByPrefix('S');
        if (preselectedSizeCode) {
            __scope.SelectVariant(preselectedSizeCode, false);
        }

        //If only option, select it by default
        if ($('input[class*="product-modal-option-1"]', __scope._container).length === 1)
            $('input[class*="product-modal-option-1"]', __scope._container).first().click();
        if ($('input[class*="product-modal-option-2"]', __scope._container).length === 1)
            $('input[class*="product-modal-option-2"]', __scope._container).first().click();
        if ($('input[class*="product-modal-option-3"]', __scope._container).length === 1)
            $('input[class*="product-modal-option-3"]', __scope._container).first().click();

        this._application.Events.On(HSN.Application.EVENT.FAVORITE_INITIALIZED,
            function (objectType, objectId, webId) {
                if ($(__scope._favoriteLink).data('object-id') !== objectId) {
                    return;
                }

                __scope._variantInfo.setVariantById(webId);
            }, this);

        this._application.Events.On(HSN.BuySelector.EVENT.FITGUIDE_MEASUREMENT_SUCCESS,
            function (sizeCode) {
                if (!__scope._useSimpleMainImage && __scope._preSelectedWebId === '0') {
                    __scope.SelectVariant(sizeCode, false);
                }
            });

        //Keith Urban products - Used to swap Left and Right hand variants
        if (this._variantInfo._variants.length) {
            var zLeft = $('input[data-label="Left Handed"]').parent();
            var zRight = $('input[data-label="Right Handed"]').parent();

            if (zLeft.length && zRight.length) {
                zLeft.insertAfter(zRight);
                zRight.click();
            }
        }

        // Set callouts info and aria-label attributes
        this._updateDisplay();
        this._updateAriaLiveElement();
    };
};

HSN.ProductOptionSelector.prototype =
{
    _container: null,

    _updateDisplay: function () {
        this._updateSelectedVariantDisplay(this._variantInfo.SelectedVariant);

        const callouts = this._variantInfo.Callouts;

        // Remove "Selected, " text from aria-label
        const groupTypeInputs = $('input[name^="product-option-group"]', this._container);
        groupTypeInputs.each((i, el) => {
            const input = $(el);
            const label = input.parent();
            const inputDesc = $('> .option-description', label).text();
            input.attr('aria-label', ((label.hasClass('checked-selected') || label.hasClass('waitlisted-selected')) ? 'Selected, ' : '') + inputDesc)
        });

        const $inputs = $('input[name^="product-modal-option"]', this._container);

        $inputs.each((i, input) => {
            const $input = $(input);
            const val = $input.attr('data-value');
            const isSelected = this._variantInfo.isCodeSelected(val);

            this._updateOptionDisplay($input, callouts[val], isSelected);

            if (isSelected) {
                $input.attr('data-checked', 'true');
                const $groupTitle = $input.closest('ul').prevAll('.tabs-label:first');
                this._updateGroupTitle($groupTitle, $input.data('label'));
            }
        });

        this._updateSelectedVariantCalloutDisplay(this._variantInfo.SelectedVariant);
    },

    _updateGroupTitle($groupTitle, text) {
        $groupTitle.find('.group-text').text(text);

        const srOnlySpan = document.createElement('span');
        var selectedText = document.createTextNode('');
        if (text !== "") {
            selectedText = document.createTextNode(' selected');
            srOnlySpan.className = 'visuallyhidden';
        } else {
            srOnlySpan.className = 'visuallyhidden empty';
        }
        srOnlySpan.appendChild(selectedText);
        if ($groupTitle.find('.group-text').length) {
            $groupTitle.find('.group-text')[0].appendChild(srOnlySpan);
        }
        this._updateAriaLiveElement();
    },

    _updateAriaLiveElement() {
        let ariaLiveMsg = 'Your current selection is :';
        let ariaLiveEle = $('#colorAndSizeSelectionMessage', this._container);
        if (ariaLiveEle.length == 0) {
            const srOnlyDiv = document.createElement('div');
            srOnlyDiv.className = 'visuallyhidden';
            srOnlyDiv.id = 'colorAndSizeSelectionMessage';
            srOnlyDiv.ariaAtomic = 'true';
            srOnlyDiv.ariaLive = 'polite';
            if ($('.product-option-selector').length) {
                $('.product-option-selector')[0].appendChild(srOnlyDiv);
                ariaLiveEle = $('#colorAndSizeSelectionMessage', this._container);
            }
        }
        if (ariaLiveEle.length) {
            const isMatrix = $('.matrix-options', this._container).length;
            var isMatrixSelect = $('.matrix-options select').length !== 0;
            if (isMatrix) {
                let titleText = $('.product-matrix-options .tabs-label label:not(".waitlist-explainer")', this._container).text();
                let titleValue = '';
                if (((!isMatrixSelect && $('.matrix-options .selected', this._container).length === 0) || (isMatrixSelect && $('.matrix-options select', this._container).val() === 'Please select...'))) {
                    const newTitleText = titleText.toLowerCase().includes('select') ? titleText.toLowerCase() : 'select ' + titleText.toLowerCase();
                    titleValue = 'please ' + newTitleText + ' first';
                } else {
                    if (isMatrixSelect) {
                        titleValue = $('.matrix-options select', this._container).val();
                    } else {
                        titleValue = $('.matrix-options .matrix-item a.selected', this._container).text();
                        const groupLabel = $('.matrix-options .matrix-item a.selected', this._container).closest('ul').prev('.groupLabel');
                        if (groupLabel.length) {
                            titleValue = groupLabel.text() + ' ' + titleValue;
                        }
                    }
                }
                ariaLiveMsg += ' ' + titleText + ' = ' + titleValue + ',';
            }

            $('label.required-selection', this._container).each(function () {
                const titleText = $(this).text() != '' ? $(this).text() : $(this).data('text');
                let titleValue = $(this).siblings('span.group-text').text();
                if (titleValue.toLowerCase().trim() !== '') {
                    titleValue = titleValue.replace('selected', '').trim();
                } else {
                    titleValue = 'please select';
                }
                ariaLiveMsg += ' ' + titleText + ' = ' + titleValue + ',';
            });
            if (ariaLiveMsg !== 'Your current selection is :') {
                ariaLiveEle.text(ariaLiveMsg.slice(0, -1));
            } else {
                ariaLiveEle.text('');
            }
        }
    },

    _updateProductImage(ele, productImage, eventName) {
        let imageContainer = $('.variant-a-left.left .product-image-container');
        let isControlVariant = false;
        if ($('.control-variant.left').length && $('.control-variant.left').is(':visible')) {
            imageContainer = $('.control-variant.left .product-image-container');
            isControlVariant = true;
        }
        if (productImage.href) {
            $('img', imageContainer).attr('src', productImage.href);
            $('a', imageContainer).attr('href', productImage.href);
            $('a', imageContainer).data('zoom', productImage.zoom);
        } else {
            let focusedBtn = ele.closest('.product-option-selector').find('.highlighted-for-tab');
            if (focusedBtn.length && eventName == 'mouseleave') {
                focusedBtn.find('input').focus();
            } else {
                let activeThumbnail;
                if (!isControlVariant) {
                    const activethumnailEle = imageContainer.closest('.left').find('.media-thumbnails-wrapper .image-container.active');
                    if (!activethumnailEle.is('.video-wrapper')) {
                        activeThumbnail = activethumnailEle.find('input');
                    }
                } else {
                    activeThumbnail = imageContainer.closest('.left').find('.product-image-thumbnails label.active input');
                }
                if (activeThumbnail.length && ((isControlVariant && imageContainer.siblings('#inline-video-container').is(':hidden')) || (!isControlVariant && imageContainer.find('.product-image').is(':visible')))) {
                    $('img', imageContainer).attr('src', activeThumbnail.attr('href'));
                    $('a', imageContainer).attr('href', activeThumbnail.attr('href'));
                    $('a', imageContainer).data('zoom', activeThumbnail.attr('data-zoom'));
                }
            }
        }
    },

    _updateOptionDisplay($input, callouts, isSelected) {
        const $label = $input.parent();
        var status = 'In Stock';

        $label.toggleClass('selected', isSelected);

        if (isSelected) {
            $input.attr('data-checked', 'true');
        }
        else {
            $input.attr('data-checked', 'false');
        }

        $label.removeClass('regular waitlisted disabled-overlay');
        if (callouts) {
            switch (callouts.Name) {
                case "Waitlist":
                case "BackOrder":
                case "ExtendedDelivery":
                    $label.addClass('waitlisted');
                    status = 'Wait listed';
                    break;
                case "SoldOut":
                    $label.addClass('disabled-overlay');
                    status = 'Sold Out';
                    break;
                case "LowInventory":
                    $label.addClass('regular');
                    break;
                default:
                    console.error("Missing Callout Logic", callouts);
            }
        }
        else {
            $label.addClass('regular');
        }
        var inputDescription = $('> .option-description', $label).text();//span with descripcion
        $input.attr('aria-label', (($label.hasClass('checked-selected') || $label.hasClass('selected')) ? 'Selected, ' : '') + inputDescription + ' ' + status);

    },

    _updateSelectedVariantDisplay: function (selectedVariant) {
        let statusText = '';
        if (selectedVariant) {
            var productFavoriteLink = $(this._favoriteLink);
            productFavoriteLink.data('web-id', selectedVariant.WebId);
            productFavoriteLink.attr('data-web-id', selectedVariant.WebId);

            this._application._getFavoriteService().UpdateFavoriteLink(productFavoriteLink);

            if (selectedVariant.Callout) {
                switch (selectedVariant.Callout.Name) {
                    case "Waitlist":
                        statusText = 'ON WAITLIST';
                        break;
                    case "LowInventory":
                        statusText = `ONLY ${selectedVariant.Callout.Remaining} LEFT`;
                        break;
                    case "BackOrder":
                    case "ExtendedDelivery":
                        statusText = 'EXTENDED DELIVERY';
                        break;
                    case "SoldOut":
                        break;
                    default:
                        console.error("Missing Callout Logic", selectedVariant.Callout);
                }
            }

            // update banner
            let banner = $('#modal-banner');
            let bannerH = banner.children('h6');
            if (selectedVariant.Callout && selectedVariant.Callout.Name === "Waitlist") {
                banner.removeClass("none");
                banner.addClass('waitlist');
                bannerH.text('WAITLIST');
            } else {
                banner.attr('class', banner.data('originalClass'));
                bannerH.text(bannerH.data('originalText'));
            }

            if (typeof dataLayer !== 'undefined') {
                var arrPV = [];
                arrPV[0] = selectedVariant.WebId;
                dataLayer[0].product_variant_id = arrPV;
            }
        }

        //actually set status text
        this._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.OPTION_STATUS_CHANGED, statusText, this._container, this.eventIdentity);

        //Check if modal is in 'edit bag' and change Update button to waitlist.
        var input = $('form > div.button-group input.add-to-bag');
        var waitlistInfo = $('.edit-item-waitlist-off');
        if (input.data('update-bag')) {
            if (statusText === 'ON WAITLIST') {
                waitlistInfo.removeClass('edit-item-waitlist-off');
                waitlistInfo.addClass('edit-item-waitlist-on');
            } else {
                waitlistInfo = $('.edit-item-waitlist-on');
                waitlistInfo.removeClass('edit-item-waitlist-on');
                waitlistInfo.addClass('edit-item-waitlist-off');
            }
        }
    },

    _updateSelectedVariantCalloutDisplay(selectedVariant) {
        var headers = this._container.find('.tabs-label');
        let lastHeader = headers.last();
        var text = this.GetCallout(selectedVariant);
        var calloutName = selectedVariant && selectedVariant.Callout ? selectedVariant.Callout.Name : '';
        var isSoldout = calloutName == 'SoldOut' ? true : false;
        var isWaitlist = calloutName == 'Waitlist' ? true : false;

        headers.toggleClass('soldout-callout', isSoldout);
        headers.find('.urgent-callout-label').text(isSoldout ? text : '');

        lastHeader.removeClass('waitlist-callout');

        let $waitlistExplainer = lastHeader.find('.waitlist-explainer');
        if (!$waitlistExplainer.length) {
            $waitlistExplainer = $('<label class="waitlist-explainer">This item is temporarily out of stock. We’ll ship it to you automatically when it’s back in stock, and we’ll only charge you if it ships. The order is canceled if it doesn’t come back in stock within 45 days.</label>');
            lastHeader.prepend($waitlistExplainer);
        }

        lastHeader.toggleClass('waitlist-callout', isWaitlist);
        lastHeader.find('.urgent-callout-label').text(text);
    },

    GetCallout: function (selectedVariant) {
        if (selectedVariant) {
            let calloutText = '';
            if (selectedVariant.Callout) {
                switch (selectedVariant.Callout.Name) {
                    case "Waitlist":
                        calloutText = 'On waitlist in';
                        break;
                    case "LowInventory":
                        calloutText = `Only ${selectedVariant.Callout.Remaining} left in `;
                        break;
                    case "BackOrder":
                    case "ExtendedDelivery":
                        calloutText = 'On extended delivery in';
                        break;
                    case "SoldOut":
                        calloutText = 'Sold out in ';
                        break;
                    default:
                        console.error("Missing Callout Logic", selectedVariant.Callout);
                }
            }
            return calloutText;
        }
        return '';
    },

    /**
        * HSN.ProductOptionSelector#ActivateOptionLabel(label) -> void
        * - label (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that
        *   will ultimately resolve one of the option labels in this product modal.
        * - sel (boolean) mark as selected?
        *
        * Modifies the label as necessary to support the activated state of the alternate image and
        * adds the active class.
        **/
    ActivateOptionLabel: function (label, sel) {
        var $label = $(label);
        var $input = $('> input', $label);//input for label

        var selectedCode = $input.attr('data-value');

        if (sel && selectedCode.substr(0, 1) === "S") { //Handle Size Variant)
            this._isPlusSizeVariantSelected = $input.data('is-plus-size-code');
        }

        // Updating of UI happens as a side effect of setting the code
        this._variantInfo.setCode(selectedCode);

        var selectedSwatch = $('.btn-styled-swatch.selected');
        //Event stuff
        var images = $(selectedSwatch).find('input').data('images');

        var isSwatch = $label.find('.btn-styled-swatch').length ? true : false;

        var prefixCode = selectedSwatch.find('input').attr('data-value');

        var swatchCode = this._variantInfo.getSelectedCodeByPrefix(prefixCode ? prefixCode : 'C');

        if (images) {
            isSwatch = true;
        }

        if (swatchCode) {
            swatchCode = swatchCode.substr(1);
        }

        this.HandleOptionChanged(images);

        //if in special Auto Ship matrix and the Auto Ship option is selected then redirect variant selections to the proper item page
        var autoShipMatrixButton = $('.matrix-autoship.auto.selected');
        var selectedVariant = this._variantInfo.SelectedVariant;
        if (autoShipMatrixButton && autoShipMatrixButton.length > 0 && selectedVariant && parseInt(selectedVariant.WebId) !== parseInt(this._preSelectedWebId)) {
            this._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, selectedVariant.WebId, '/products/slug/' + selectedVariant.WebId, this.eventIdentity);
        }
        else {
            this._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.OPTION_CHANGED, images, isSwatch, swatchCode, this._isPlusSizeVariantSelected, this.eventIdentity);
        }
    },

    /**
        * HSN.ProductOptionSelector#DeactivateOptionLabel(label) -> void
        * - label (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will
        *   ultimately resolve one of the option labels in this product modal.
        *
        * Deactivate label and set description text to currently selected option.
        * Clean all labels, spans and status text
        **/
    DeactivateOptionLabel: function (label) {
        var scope = this;

        if (!label) {
            return;
        }

        var $label = $(label);
        var $input = $('> input', $label);//input corresponding to label
        $input.attr('data-checked', 'false');
        $label.removeClass('checked');// deactivate label

        // Updating of UI happens as a side effect of setting the code
        this._variantInfo.unsetCode($input.attr('data-value'));

        //populate input group description to selected or empty if no selected
        var checkedOption = $('input[name="' + $input.attr('name') + '"][data-checked="true"]', scope._container);
        var checkOptionDataLabel = checkedOption.data('label') || '';
        let $groupTitle = $label.closest('ul').prevAll('.tabs-label:first');
        this._updateGroupTitle($groupTitle, checkOptionDataLabel);
    },

    /**
        * HSN.ProductOptionSelector#HandleOptionChanged() -> void
        *
        * Code that runs when an option is changed in productoptionselector.
        **/
    HandleOptionChanged: function (alternateImages) {
        var scope = this;
        if (scope._imageContainer && alternateImages) {
            // Change default image
            var isPlusSize = scope.IsPlusSizeGroupSelected();
            if (isPlusSize) {
                scope._productImage.href = alternateImages.detailPlusSize;
                scope._productImage.zoom = alternateImages.zoomPlusSize;
            }
            else {
                scope._productImage.href = alternateImages.detail;
                scope._productImage.zoom = alternateImages.zoom;
            }

            scope.SwapMainImage(alternateImages, '', isPlusSize);
        }
    },

    SelectVariant: function (variantCode, selectOnlyGroup) {
        var scope = this;

        var $sizeVariantInput = $('input[name^="product-modal-option"][data-value="' + variantCode + '"]', scope._container);
        var $sizeGroup = $sizeVariantInput.closest('ul');
        var $sizeGroupTab = $('div[data-href="#' + $sizeGroup.prop('id') + '"].label', $sizeGroup.parent());

        $sizeGroupTab.click();
        if (!selectOnlyGroup && $sizeVariantInput && !$sizeVariantInput.is('[data-checked="true"]')) {
            $sizeVariantInput.click();
            $sizeVariantInput.change();
        }
    },

    IsPlusSizeGroupSelected: function () {
        return this._isPlusSizeVariantSelected;
    },

    GetSelectedVariant: function (variantType, grouping) {
        if (!variantType) {
            return false;
        }

        const selectedCode = this._variantInfo.getSelectedCodeByPrefix(variantType);

        if (selectedCode) {
            let input = $('input[name^="product-modal-option"]', this._container).filter((i, e) => $(e).attr('data-value') === selectedCode);

            if (input.length === 1) {
                return $(input).parent();
            }
        }

        return null;
    },

    SetDefaultImage: function () {
        var scope = this;
        var isPlusSize = scope.IsPlusSizeGroupSelected();
        var images = scope._imageContainer.find('img').data('images');
        if (scope._imageContainer && images) {
            if (isPlusSize) {
                scope._productImage.href = images.detailPlusSize;
                scope._productImage.zoom = images.zoomPlusSize;
            }
            else {
                scope._productImage.href = images.detail;
                scope._productImage.zoom = images.zoom;
            }
        }
    },

    GetBestZoomImage: function(images) {
        if (typeof images === 'string') {
            return images;
        }
        return images[images.length > 1 ? 1 : 0];
    },

    SwapMainImage: function (images, imageName, isPlusSize) {
        var scope = this;
        var changed = false;
        var img = $(scope._isMobile && !scope._useSimpleMainImage ? 'img.zoom-image' : 'img', scope._imageContainer);
        var curSrc = img.attr('src');

        if (scope._isMobile && !scope._useSimpleMainImage) {
            if (isPlusSize) {
                if (images.detailPlusSize) {
                    img.attr('src', images.detailPlusSize);

                    if (curSrc != images.detailPlusSize) {
                        changed = true;
                    }
                }
                if (images.zoomPlusSize) {
                    img.data('zoom-url', scope.GetBestZoomImage(images.zoomPlusSize));
                }
            }
            else {
                if (images.detail) {
                    img.attr('src', images.detail);

                    if (curSrc != images.detail) {
                        changed = true;
                    }
                }
                if (images.zoom) {
                    img.data('zoom-url', scope.GetBestZoomImage(images.zoom));
                }
            }

            var zoomie = scope._imageContainer.data('zoomie');
            if (zoomie) {
                zoomie.reset();
            }
        }
        else {
            var anchor = $('a', scope._imageContainer);
            if (isPlusSize) {
                if (images.detailPlusSize) {
                    img.attr('src', images.detailPlusSize)
                        .attr('alt', imageName);
                    anchor.attr('href', images.detailPlusSize);

                    if (curSrc != images.detailPlusSize) {
                        changed = true;
                    }
                }
                if (images.zoomPlusSize) {
                    anchor.data('zoom', images.zoomPlusSize);
                }
            }
            else {
                if (images.detail) {
                    img.attr('src', images.detail)
                        .attr('alt', imageName);
                    anchor.attr('href', images.detail);

                    if (curSrc != images.detail) {
                        changed = true;
                    }
                }
                if (images.zoom) {
                    anchor.data('zoom', images.zoom);
                }
            }
        }

        if (changed) {
            scope._application.Events.Trigger(HSN.ProductOptionSelector.EVENT.MAIN_IMAGE_CHANGED, scope.eventIdentity);
        }
    },
    GetImageData: function(img) {
        var scope = this;
        var data = img.data('images');
        if (!data) {
            var imgData = img.data();
            data = {
                detail: imgData.imagePath,
                zoom: scope.GetBestZoomImage(imgData.zoomPath),
                detailPlusSize: imgData.plusImagePath,
                zoomPlusSize: scope.GetBestZoomImage(imgData.plusZoomPath)
            }
        }

        return data;
    },
};

/**
    * HSN.ProductOptionSelector.EVENT = Object
    *
    * An enumeration of events an [[HSN.Flyout]] can raise:
    * - OPTION_CHANGED: Fires when an option selection changes.
    **/
HSN.ProductOptionSelector.EVENT =
{
    OPTION_CHANGED: 'HSN.ProductOptionSelector:OPTION_CHANGED',
    GROUP_CHANGED: 'HSN.ProductOptionSelector:GROUP_CHANGED',
    MATRIX_OPTION_SELECTED: 'HSN.ProductOptionSelector:MATRIX_OPTION_SELECTED',
    OPTION_STATUS_CHANGED: 'HSN.ProductOptionSelector:OPTION_STATUS_CHANGED',
    MAIN_IMAGE_CHANGED: 'HSN.ProductOptionSelector:MAIN_IMAGE_CHANGED',
};



// WEBPACK FOOTER //
// ./assets/js/HSN/ProductOptionSelector.js